module.exports = __webpack_public_path__ + "static/media/TestTypeOne.bc91d7d6.svg";